import React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { AppButton } from '../../common/components/AppButton';
import { Grid } from '@material-ui/core';
import { AppConfig } from '../../AppConfig';
import { AppHelper } from '../../helpers/AppHelper';
import { Helper } from '../../common/helpers/Helper';


export function SubEntityCardLite(props) {
  const renderImage = (item) => {
    if (item.image) {
      return <img alt={Helper.getString('tileIcon')} className={css(Styles.gridIcon)} width={18} height={18} src={item.image} />
    }
    if (item.icon) {
      return <item.icon className={css(Styles.gridIcon)} />
    }
  }

  return (
    <div className={css(Styles.subEntityContainer)}>
      <div className={css(Styles.entityHeader)}>
        <div className={css(Styles.titleContainer)}>
          <span className={css(Styles.entityTitle)}>{props.entityTitle}</span>
          <span>ID: {props.item.id}</span>
          {props.item && AppHelper.renderCampaignState(props.item, props.org)}
        </div>
        {props.openModalForEdit && <div onClick={() => props.openModalForEdit()} className={css(Styles.btnTtitle)}>Edit</div>}
      </div>
      <div className={css(Styles.gridContainer)}>
        <Grid container spacing={2}>
          {props.items.map(item => {
            return (
              <Grid key={item.key} item className={css(Styles.gridItem)} lg={4} xs={12} sm={12} md={6}>
                <span className={css(Styles.gridItemTitle)}>{item.title}</span>
                <div className={css(Styles.gridSubContainer)}>
                  {renderImage(item)}
                  <span>{item.displayValue || '-'}</span>
                </div>
              </Grid>
            )
          })}
        </Grid>
      </div>
    </div>
  )
}

const Styles = StyleSheet.create({
  subEntityContainer: {
    padding: 20,
    borderRadius: 16,
    backgroundColor: '#ffffff',
    '@media (max-width: 767px)': {
      padding: 10
    }
  },
  entityHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  entityTitle: {
    fontSize: 22,
    fontWeight: 500,
    '@media (max-width: 767px)': {
      fontSize: 18,
    }
  },
  gridContainer: {
    marginTop: 10,
    padding: '10px 20px',
    width: '100%',
    boxSizing: 'border-box'
  },
  gridItem: {
    //padding: 10,
  },
  gridItemTitle: {
    fontSize: 16,
    fontWeight: 500
  },
  gridSubContainer: {
    marginTop: 10,
    display: 'flex',
    alignItems: 'center',
    color: '#747474',
    fontSize: 14,
    fontWeight: 400
  },
  gridIcon: {
    marginRight: 10
  },
  btnTtitle: {
    color: AppConfig.TINT_COLOUR,
    fontWeight: 600,
    cursor: 'pointer'
  },
  titleContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    '@media (max-width: 767px)': {
      flexDirection: 'column',
      alignItems: 'flex-start'
    }
  }
})



// WEBPACK FOOTER //
// ./src/components/advertiser/SubEntityCardLite.js